import React, { useEffect, useState } from "react";
import axios from "axios";
import { getTemplates } from "../services/smsTemplateApi";
import "./smsForm.css";
import "./SmsSendPage.css";

const SmsSendPage = () => {
    const [templates, setTemplates] = useState([]);
    const [form, setForm] = useState({
        templateCode: "",
        mobileNumber: "",
        variables: [""],
    });
    const [sending, setSending] = useState(false);

    useEffect(() => {
        getTemplates().then((res) => setTemplates(res.data));
    }, []);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleVariableChange = (index, value) => {
        const updated = [...form.variables];
        updated[index] = value;
        setForm({ ...form, variables: updated });
    };

    const addVariable = () => {
        setForm({ ...form, variables: [...form.variables, ""] });
    };

    const removeVariable = (index) => {
        const updated = form.variables.filter((_, i) => i !== index);
        setForm({ ...form, variables: updated });
    };

    const handleSubmit = async () => {
        if (!form.templateCode || !form.mobileNumber) {
            alert("Template and Mobile Number are required");
            return;
        }

        setSending(true);
        try {
            await axios.post("https://sms.brightechsoftware.com/api/v1/sms/send", form);
            alert("SMS sent successfully ✅");

            setForm({
                templateCode: "",
                mobileNumber: "",
                variables: [""],
            });
        } catch (err) {
            alert(err.response?.data || "Error sending SMS");
        } finally {
            setSending(false);
        }
    };

    return (
        <div className="page">

            {/* HEADER */}
            <div className="header-card">
                <h2>🚀 Send SMS</h2>
                <p>Send a templated SMS message to a mobile number</p>
            </div>

            {/* FORM CARD */}
            <div className="card send-card">
                <div className="form-group">
                    <label>Template</label>
                    <select
                        name="templateCode"
                        value={form.templateCode}
                        onChange={handleChange}
                    >
                        <option value="">Select Template</option>
                        {templates.map((t) => (
                            <option key={t.id} value={t.templateCode}>
                                {t.templateCode}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label>Mobile Number</label>
                    <input
                        name="mobileNumber"
                        value={form.mobileNumber}
                        onChange={handleChange}
                        placeholder="Enter 10 digit number"
                        maxLength={10}
                    />
                </div>

                {/* VARIABLES */}
                <div className="form-group">
                    <label>Variables</label>

                    {form.variables.map((v, i) => (
                        <div key={i} className="variable-row">
                            <input
                                value={v}
                                onChange={(e) => handleVariableChange(i, e.target.value)}
                                placeholder={`Variable ${i + 1}`}
                            />
                            {form.variables.length > 1 && (
                                <button
                                    type="button"
                                    className="remove-var-btn"
                                    onClick={() => removeVariable(i)}
                                >
                                    ✕
                                </button>
                            )}
                        </div>
                    ))}

                    <button type="button" className="add-btn" onClick={addVariable}>
                        + Add Variable
                    </button>
                </div>

                <div className="button-group">
                    <button
                        className="button save send-btn"
                        onClick={handleSubmit}
                        disabled={sending}
                    >
                        {sending ? "Sending..." : "Send SMS"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SmsSendPage;